import { TemplateOptionValue } from "./types";

type TemplateOption = {
  value: TemplateOptionValue;
  label: string;
  icon: string;
};

export const TEMPLATE_OPTIONS: TemplateOption[] = [
  {
    value: "old",
    label: "Default",
    icon: "https://cdn.1cdn.app/application/LOUISEBOT/2502031554528_email_temp_default-min.png",
  },
  {
    value: "white",
    label: "White",
    icon: "https://cdn.1cdn.app/application/LOUISEBOT/25020312585997_email_temp_white-min.png",
  },
  {
    value: "elegant",
    label: "Elegant",
    icon: "https://cdn.1cdn.app/application/LOUISEBOT/25020315545150_email_temp_elegant-min.png",
  },
  {
    value: "default",
    label: "Cyan",
    icon: "https://cdn.1cdn.app/application/LOUISEBOT/2502031258594_email_temp_blue-min.png",
  },
  {
    value: "dark",
    label: "Dark",
    icon: "https://cdn.1cdn.app/application/LOUISEBOT/25020312585854_email_temp_dark-min.png",
  },
  {
    value: "winter",
    label: "Winter",
    icon: "https://cdn.1cdn.app/application/LOUISEBOT/25020315545118_email_temp_winter-min.png",
  },
];

export const TEMPLATE_KEYS: Record<TemplateOptionValue, string> = {
  old: "sum_user_message",
  white: "sum_user_message_white",
  elegant: "sum_user_message_elegant",
  default: "sum_user_message_default",
  dark: "sum_user_message_dark",
  winter: "sum_user_message_winter",
};

export const DEFAULT_TEMPLATE: TemplateOptionValue = TEMPLATE_OPTIONS[0].value;

export const INTRO_PLACEHOLDERS = [
  "{{user_email}}",
  "{{user_first_name}}",
  "{{user_last_name}}",
] as const;

export const MAX_LENGTH = 3000;
export const MIN_GOOD_LENGTH = 50;
export const GREEN_LIMIT = 2400;
export const ORANGE_LIMIT = 3000;
